import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function Logo() {
  const {
    homeUrl,
    backLinkBesideLogoCallback,
    logo,
  } = useContext(ConfiguratorContext)

  return (
    <div className='logo-container'>
      {
        backLinkBesideLogoCallback && (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='30'
            height='30'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='feather feather-chevron-left'
            onClick={backLinkBesideLogoCallback}
          >
            <polyline points='15 18 9 12 15 6'/>
          </svg>
        )
      }

      <a className='logo' href={homeUrl}>
        <img src={logo.url} alt={logo.alt}/>
      </a>
    </div>
  )
}
